import React from 'react';
import { Select, Spin, Table, Tooltip, Button, Icon, Input, Col, Row } from 'antd';
import { openNotification } from '../../util/notificaciones';
import UsuariosRequest from '../../services/Usuarios';
import CatalogosRequest from '../../services/Catalogos';
import NewFormUsuarios from './NewFormUsuario';
import SegmentosPVRequest from '../../services/SegmentosPV';
import PedidosRequest from '../../services/Pedidos';
import ResponsiveCard from '../Common/ResponsiveCard';
import BaseComponent from '../Common/BaseComponent';

const { Option } = Select;


/**
 * Clase para ver el proceso de mostrar usuarios
 */
export default class Usuarios extends BaseComponent {
    state = {
        cargando: false,
        filterText: "",
        paginacion: {},
        filtros: {
            nombre: undefined,
            plaza: undefined,
            rol: undefined,
            estatus: undefined,
            page: undefined,
            segmento: undefined
        },
        arrPlazas: [],
        arrRoles: [],
        plazaSelected: null,
        rolSelected: null,
        estatusSelected: null,
        disableDeleteFilters: true,
        modalUsuarios: false,
        usuarioSelected: null,
        segmentoSelected: null,
        usuarioSegmento: null,
        arrSegmentos: []
    }

    /**
     * Comportamiento del componente al mostrar los artículos
     */
    componentDidMount = () => {
        let state = { ...this.state }
        this.setState({ cargando: true }, () => {
                CatalogosRequest.ListarPlazas().then(response => {
                    state.arrPlazas = response.data;
                    return CatalogosRequest.ListarRoles();
                })
                .then(response => {
                    state.arrRoles = response.data;
                    if (["Administrador", "SuperAdmin"].includes(localStorage.getItem("role"))) {
                        return SegmentosPVRequest.CargarSegmentosTabla();
                    } else {
                        return PedidosRequest.ListarSitiosSupervisor();
                    }
                })
                .then(response => {
                    if (["Administrador", "SuperAdmin"].includes(localStorage.getItem("role"))) {
                        state.arrSegmentos = response.data
                    } else {
                        if (response.data.segmento) {
                            state.segmentoUsuario = response.data.segmento;
                            state.filtros.segmento = response.data.segmento;
                        } else {
                            openNotification(
                                "El usuario no tiene asignado ningún segmento.",
                                "Error al cargar segmentos del usuario",
                                false,
                            );
                            throw new Error("Error al cargar segmentos del usuario");
                        }
                    }
                    state.cargando = false;
                    return UsuariosRequest.ListarUsuarios(state.filtros)
                })
                .then(response => {
                    state.arrUsuarios = response.data.results;
                    state.paginacion = {
                        current: 1,
                        total: response.data.count,
                        onChange: this.handlePaginaChange,
                        pageSize: 10,
                        showTitle: false
                    }
                    this.setState(state)
                })
                .catch(err => {
                    this.setState({ cargando: false })
                    openNotification(
                        err.response.data.error,
                        "Error",
                        false
                    )
                })
        });
    }

    /**
     * Función que se ejecuta cuando se da clic en página siguiente
     * @param: paginaSiguiente. valor de la página siguiente
     * @return: nada. se establece un nuevo valor para la el texto a filtrar.
     */
    handlePaginaChange = (paginaSiguiente) => {
        let state = { ...this.state };
        for (var key in state.filtros) {
            if (state.filtros[key] === null || state.filtros[key] === undefined) {
                delete state.filtros[key];
            }
        }

        state.filtros.page = paginaSiguiente
        state.cargando = true
        this.setState(state, () => {
            UsuariosRequest.ListarUsuarios(state.filtros)
                .then(response => {
                    state.arrUsuarios = response.data.results;
                    state.cargando = false;
                    state.paginacion = {
                        current: paginaSiguiente,
                    }
                    this.setState(state)
                })
                .catch(err => {
                    this.setState({ cargando: false })
                    openNotification(
                        "Ha ocurrido un error al listar los usuarios.",
                        "Error al listar usuarios",
                        false
                    )
                })
        })
    }

    /**
     * Función que se ejecuta cuando el usuario introduce algo en la barra de búsqueda
     * @param: value. valor de la búsqueda
     * @return: nada. se establece un nuevo valor para la el texto a filtrar.
     */
    filterText = (value) => {
        let state = { ...this.state };
        let buscar = false;

        if (value.trim() !== state.filterText.trim()) buscar = true
        state.filterText = value;
        state.filtros.nombre = value.trim() === "" ? undefined : value.trim()
        this.setState(state);
        if (buscar) {
            clearTimeout(state.timer)
            state.timer = setTimeout(() => {
                this.filtrarBack();
            }, 1000);
        }
    }

    /**
     * Función para asignar la plaza al combo
     * @param: value. opción seleccionada
     * @return: nada
     */
    onChangePlaza = (value) => {
        let state = { ...this.state };
        state.filtros.plaza = value === undefined ? null : value;
        state.plazaSelected = value === undefined ? null : value;
        this.setState(state, this.filtrarBack)
    }

    /**
     * Función para asignar el rol al combo
     * @param: value. opción seleccionada
     * @return: nada
     */
    onChangeRol = (value) => {
        let state = { ...this.state };
        state.filtros.rol = value === undefined ? null : value;
        state.rolSelected = value === undefined ? null : value;
        this.setState(state, this.filtrarBack)
    }

    /**
     * Función para asignar el estatus al combo
     * @param: value. opción seleccionada
     * @return: nada
     */
    onChangeEstatus = (value) => {
        let state = { ...this.state };
        state.filtros.estatus = value === undefined ? null : value === 1 ? true : false;
        state.estatusSelected = value === undefined ? null : value;
        this.setState(state, this.filtrarBack)
    }

    /**
     * Función para asignar el segmento al combo
     * @param: value. opción seleccionada
     * @return: nada
     */
    onChangeSegmento = (value) => {
        let state = { ...this.state };
        state.filtros.segmento = value === undefined ? null : value;
        state.segmentoSelected = value === undefined ? null : value;

        this.setState(state, this.filtrarBack)
    }

    /**
     * Función que muestra el formulario de usuario
     * @param: nada.
     * @return: nada.
     */
    showModal = () => {
        this.setState({ modalUsuarios: true })
    }

    /**
     * Función que esconde el modal de estatus
     * @param: value. valor para esconder el modal
     * @return: nada.
     */
    esconderModal = (value) => {
        let state = { ...this.state }
        if (value) {
            state.modalUsuarios = false;
            state.usuarioSelected = null;
            this.setState(state, () => {
                this.filtrarBack()
            })
        }
        this.setState({ modalUsuarios: false, usuarioSelected: null })
    }

    /**
     * Función que se encarga de hacer las peticion en el back para filtrar
     */
    filtrarBack = () => {
        let state = { ...this.state };
        for (var key in state.filtros) {
            if (state.filtros[key] === null || state.filtros[key] === undefined) {
                delete state.filtros[key];
            }
        }
        state.filtros.page = 1;
        state.cargando = true;

        if (state.filterText.trim() === "" &&
            state.plazaSelected === null &&
            state.rolSelected === null &&
            state.estatusSelected === null &&
            state.segmentoSelected === null
        ) {
            state.disableDeleteFilters = true
        } else {
            state.disableDeleteFilters = false
        }

        this.setState(state, () => {
            UsuariosRequest.ListarUsuarios(state.filtros)
                .then(response => {
                    state.arrUsuarios = response.data.results;
                    state.cargando = false;
                    state.paginacion = {
                        current: 1,
                        total: response.data.count,
                        onChange: this.handlePaginaChange,
                        pageSize: 10,
                        showTitle: false
                    }
                    this.setState(state)
                })
                .catch(err => {
                    this.setState({ cargando: false })
                    openNotification(
                        "Ha ocurrido un error al listar los usuarios.",
                        "Error al listar usuarios",
                        false
                    )
                })
        })
    }

    /**
     * Función para limpiar todos los filtros que han
     * sido manipulados por el usuario.
     * @param: nada
     * @return: nada
     */
    cleanFilters = () => {
        let state = { ...this.state }
        state.disableDeleteFilters = true;
        state.filtros.nombre = undefined;
        state.filtros.plaza = undefined;
        state.filtros.rol = undefined;
        state.filtros.estatus = undefined;
        state.filtros.segmento = undefined;
        state.filtros.page = 1;
        state.filterText = "";
        state.plazaSelected = null;
        state.rolSelected = null;
        state.estatusSelected = null;
        state.segmentoSelected = null;
        this.setState(state, this.filtrarBack);
        openNotification("Los filtros se han limpiado correctamente.", "Filtros limpiados correctamente", true);
    }

    render() {
        const columnaUsuarios = [
            {
                title: "Nombre",
                dataIndex: "nombre",
                key: "nombre",
                show: true,
            },
            {
                title: "Usuario",
                dataIndex: "username",
                key: "username",
                show: !this.state.isPos,
            },
            {
                title: "Correo",
                dataIndex: "email",
                key: "email",
                show: true,
            },
            {
                title: "Plaza",
                dataIndex: "plaza_nombre",
                key: "plaza_nombre",
                render: plaza_nombre => {
                    if (!plaza_nombre || plaza_nombre.length === 0) {
                        return <span>Sin asignar</span>;
                    }

                    const plazasTexto = plaza_nombre.join(", ");
                    
                    return (
                        <Tooltip title={plazasTexto}>
                            <span style={{
                                display: "inline-block",
                                maxWidth: 150,
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis"
                            }}>
                                {plazasTexto}
                            </span>
                        </Tooltip>
                    );
                },
                show: !this.state.isPos,
            },
            {
                title: "Rol",
                dataIndex: "rol_nombre",
                key: "rol_nombre",
                show: !this.state.isPos,
            }, 
            {
                title: "Segmento",
                dataIndex: "segmento_nombre",
                key: "segmento_nombre",
                show: !this.state.isPos,
                render: segmento_nombre => {
                    if (!segmento_nombre) {
                        return <span>Sin asignar</span>;
                    }

                    return (
                        <Tooltip title={segmento_nombre}>
                            <span style={{
                                display: "inline-block",
                                maxWidth: 150,
                                whiteSpace: "nowrap",
                                overflow: "hidden", 
                                textOverflow: "ellipsis"
                            }}>
                                {segmento_nombre}
                            </span>
                        </Tooltip>
                    );
                }
            }, 
            {
                title: 'Acciones',
                dataIndex: 'Acciones',
                key: 'Acciones',
                show: true,
                render: (value, record) => (
                    <div>
                        {record.configurado &&
                            <div>
                                <span style={{ marginRight: 5 }}>
                                    <Tooltip placement="top" title={"Ver detalle de usuario"}>
                                        <Button
                                            icon="eye"
                                            id='boton-detalle-usuario-modulo'
                                            onClick={() =>{
                                                this.setState({
                                                    usuarioSelected: record,
                                                    modo: 'ver'
                                                }, this.showModal())
                                            }}
                                        >
                                        </Button>
                                    </Tooltip>
                                </span>
                                <span className={localStorage.getItem("role") === 'Supervisor de Operaciones Drive' ? 'display-none' : ''} style={{ marginRight: 5 }}>
                                    <Tooltip placement="top" title={"Editar usuario"}>
                                        <Button
                                            icon="edit"
                                            id='boton-editar-usuario-modulo'
                                            onClick={() =>{
                                                this.setState({
                                                    usuarioSelected: record,
                                                    modo: 'editar'
                                                }, this.showModal())
                                            }}
                                        >
                                        </Button>
                                    </Tooltip>
                                </span>
                            </div>
                        }
                        {!record.configurado &&
                            <span className={localStorage.getItem("role") === 'Supervisor de Operaciones Drive' ? 'display-none' : ''} style={{ marginRight: 5 }}>
                                <Tooltip placement="top" title={"Configurar usuario"}>
                                    <Button
                                        icon="setting"
                                        id='boton-configurar-usuario-modulo'
                                        onClick={() =>{
                                            this.setState({
                                                usuarioSelected: record,
                                                modo: 'configurar'
                                            }, this.showModal())
                                        }}
                                    >
                                    </Button>
                                </Tooltip>
                            </span>
                        }
                    </div>
                )
            }
        ]
        return (
            <ResponsiveCard id="ParentSize"
                title="Módulo usuarios"
            >
                <div className="panel-block">
                    <div>
                        <Row gutter={12}>
                            <Col span={8}>
                                <div className="center">Búsqueda:</div>
                                <Tooltip
                                    placement="top"
                                    title="Buscar usuario">
                                    <Input
                                        autoFocus={true}
                                        maxLength={70}
                                        id="input-buscar-usuarios-modulo"
                                        placeholder="Buscar por Nombre / Usuario / Correo"
                                        onChange={(e) => this.filterText(e.currentTarget.value)}
                                        value={this.state.filterText}
                                    />
                                </Tooltip>
                            </Col>
                            <Col className={['Administrador', 'SuperAdmin'].includes(localStorage.getItem("role")) ? '' : 'display-none'} span={8}>
                                <Tooltip placement="top" title="Buscar usuarios por segmento">
                                    <div className="center">Segmento:</div>
                                    <Select
                                        allowClear={true}
                                        style={{ width: '100%' }}
                                        notFoundContent='No hay opciones'
                                        placeholder="Seleccionar..."
                                        defaultValue={null}
                                        showSearch
                                        id="select-filtros-segmento-usuarios"
                                        defaultActiveFirstOption={false}
                                        optionFilterProp="children"
                                        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                        value={this.state.segmentoSelected}
                                        onChange={this.onChangeSegmento}
                                    >
                                        <Option key={0} value={null} disabled={true}>Seleccionar...</Option>
                                        {
                                            this.state.arrSegmentos.length > 0 &&
                                            this.state.arrSegmentos.map(obj => {
                                                return (
                                                    <Option
                                                        key={obj.id}
                                                        value={obj.id}>
                                                        {obj.nombre}
                                                    </Option>
                                                )
                                            })
                                        }
                                    </Select>
                                </Tooltip>
                            </Col>
                            <Col span={8}>
                                <Tooltip placement="top" title="Buscar usuarios por plaza">
                                    <div className="center">Plaza:</div>
                                    <Select
                                        allowClear={true}
                                        style={{ width: '100%' }}
                                        notFoundContent='No hay opciones'
                                        placeholder="Seleccionar..."
                                        defaultValue={null}
                                        showSearch
                                        id="select-filtros-plaza-usuarios"
                                        defaultActiveFirstOption={false}
                                        optionFilterProp="children"
                                        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                        value={this.state.plazaSelected}
                                        onChange={this.onChangePlaza}
                                        disabled={this.state.segmentoSelected === null}
                                    >
                                        <Option key={0} value={null} disabled={true}>Seleccionar...</Option>
                                        {
                                            this.state.arrPlazas.length > 0 &&
                                            this.state.arrPlazas.map(obj => {
                                                return (
                                                    <Option
                                                        key={obj.id}
                                                        value={obj.id}>
                                                        {obj.nombre}
                                                    </Option>
                                                )
                                            })
                                        }
                                    </Select>
                                </Tooltip>
                            </Col>
                        </Row> <br />
                        <Row gutter={12}>
                            <Col span={8}>
                                <Tooltip placement="top" title="Buscar usuarios por rol">
                                    <div className="center">Rol:</div>
                                    <Select
                                        allowClear={true}
                                        style={{ width: '100%' }}
                                        notFoundContent='No hay opciones'
                                        placeholder="Seleccionar..."
                                        defaultValue={null}
                                        showSearch
                                        id="select-filtros-rol-usuarios"
                                        defaultActiveFirstOption={false}
                                        optionFilterProp="children"
                                        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                        value={this.state.rolSelected}
                                        onChange={this.onChangeRol}
                                    >
                                        <Option key={0} value={null} disabled={true}>Seleccionar...</Option>
                                        {
                                            this.state.arrRoles.length > 0 &&
                                            this.state.arrRoles.map(obj => {
                                                return (
                                                    <Option
                                                        key={obj.id}
                                                        value={obj.id}>
                                                        {obj.descripcion}
                                                    </Option>
                                                )
                                            })
                                        }
                                    </Select>
                                </Tooltip>
                            </Col>
                            <Col span={8}>
                                <Tooltip placement="top" title="Buscar usuarios por estatus">
                                    <div className="center">Estatus:</div>
                                    <Select
                                        allowClear={true}
                                        style={{ width: '100%' }}
                                        notFoundContent='No hay opciones'
                                        placeholder="Seleccionar..."
                                        defaultValue={null}
                                        showSearch
                                        id="select-filtros-estatus-usuarios"
                                        defaultActiveFirstOption={false}
                                        optionFilterProp="children"
                                        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                        value={this.state.estatusSelected}
                                        onChange={this.onChangeEstatus}
                                    >
                                        <Option key={0} value={null} disabled={true}>Seleccionar...</Option>
                                        <Option key={1} value={1}>Configurado</Option>
                                        <Option key={2} value={2}>No Configurado</Option>
                                    </Select>
                                </Tooltip>
                            </Col>
                            <Col span={this.state.isPos ? 3 : 2}>
                                <div className="center-down" style={{ marginLeft: this.state.isPos ? "0px": ""}}>
                                    <Tooltip placement="top" title="Borrar filtros">
                                        <Button id="boton-borrar-filtros-usuarios" type="default" icon="delete" className={this.state.disableDeleteFilters ? 'disableBtn' : ''} style={{ width: '80%', marginBottom: "30px", marginTop: '1.3em' }} onClick={this.cleanFilters}></Button>
                                    </Tooltip>
                                </div>
                            </Col>
                        </Row>
                    </div>

                    <Spin
                        tip="Cargando..."
                        indicator={<Icon type="loading" style={{ fontSize: 24, color: "#e0cbae" }} spin />}
                        spinning={this.state.cargando}
                        style={{ color: "#e0cbae", backgroundColor: "rgb(255,255,255,0.8)" }}>
                        <Table 
                            size="small"
                            locale={{ emptyText: 'No se han encontrado resultados' }}
                            rowKey={usuarios => usuarios.id}
                            rowClassName={(usuario) => usuario.configurado ? '' : 'back-grey'}
                            columns={columnaUsuarios.filter(r => r.show)}
                            dataSource={this.state.arrUsuarios}
                            pagination={this.state.paginacion}
                        />
                    </Spin>
                </div>
                <NewFormUsuarios
                    esconderModal={this.esconderModal}
                    visible={this.state.modalUsuarios}
                    modo={this.state.modo}
                    usuario_selected={this.state.usuarioSelected}
                >
                </NewFormUsuarios>
            </ResponsiveCard>
        )
    }
}
